import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontElectricEngineProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function FrontElectricEngine(props: FrontElectricEngineProps) {
  return (
    <svg
      width="84"
      height="98"
      viewBox="0 0 84 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 202, left: 244}}
      onClick={props.onClick}
    >
      <path
        d="M83 81C83 83 81 83 81 83H75L75 85C75 87 73 87 73 87L72 87V88C72 93 67 93 67 93L66 93V95C66 97 64 97 64 97H38H12C12 97 10 97 10 95V93L9 93C9 93 4 93 4 88V87L3 87C3 87 1 87 1 85V49V13C1 11 3 11 3 11H4V10C4 5.00001 9 5.00002 9 5.00002L10 5V3C10 1 12 1 12 1H38H64C64 1 66 1 66 3V5L67 5.00002C67 5.00002 72 5.00001 72 10V11H73C73 11 75 11 75 13L75 15H81C81 15 83 15 83 17V49V81Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M72 11L72 10C72 5.00001 67 5.00002 67 5.00002H38H9C9 5.00002 4 5.00001 4 10V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M66 5V3C66 1 64 1 64 1H38H12C12 1 10 1 10 3V5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M72 87L72 88C72 93 67 93 67 93H38H9C9 93 4 93 4 88V87"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M66 93V95C66 97 64 97 64 97H38H12C12 97 10 97 10 95V93"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M75 83L75 85C75 87 73 87 73 87H38H3C3 87 1 87 1 85V49V13C1 11 3 11 3 11H38H73C73 11 75 11 75 13L75 15"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M81 83H73H65C65 83 63 83 63 81V49V17C63 15 65 15 65 15H73H81C81 15 83 15 83 17V49V81C83 83 81 83 81 83Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M33 11V87"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M43 11V87"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path d="M51 11V87" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M25 11V87" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M9 11V87" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M17 11V87"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeDasharray="2 2"
      />
      <path
        d="M59 11V87"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeDasharray="2 2"
      />
    </svg>
  );
}
